
import { useQuery } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { ILandlordOnboardInvite } from 'src/api/onboard-api';
import { simpleKy } from 'src/services/api/ky';
import { queryKeys } from 'src/services/api/constants';
import { isHTTPError } from 'src/common/api-utils';
import { isStandardErrorResponse } from 'src/api/common';

const PATH = 'api/landlord/onboard/details-from-code';

type ApiResponse = {
    invite: ILandlordOnboardInvite;
};

type Response = ApiResponse['invite'];

export const useOnboardingInvitation = (code: string, enabled?: boolean) => {
    return useQuery<Response, IStandardErrorResponse>(
        [queryKeys.onboardingInvitation, code],
        async () => {
            try {
                const response = await simpleKy(PATH, {
                    searchParams: {
                        code
                    },
                }).json<ApiResponse>();

                return response.invite;
            } catch (error) {
                if (isHTTPError(error)) {
                    const errorResponse = await error.response.json();
                    if (isStandardErrorResponse(errorResponse)) {
                        throw errorResponse;
                    }
                }

                throw {
                    status: 'error',
                    msg: 'Invalid code. Please try again.',
                };
            }
        }, {
            enabled: enabled !== false,
            // backend returns `404` if the code is invalid and react-query retiries on `404` by default
            retry: false,
            // we don't want to refetch the data when the window regains focus for the same reason as above
            refetchOnWindowFocus: false,
        }
    );
};